export abstract class AData<$Data> {

    protected abstract doLoad(): Promise<$Data>;
    protected abstract getCached(): $Data;
    protected abstract storeCached(data: $Data); void;

    public get(): $Data {
        return this.getCached();
    }

    public load(): Promise<$Data> {
        return this.doLoad()
            .then((resp) => {
                this.storeCached(resp);
                return resp;
            })
            .catch((err) => {
                console.error(err);
                throw err;
            })
    }

    public getOrLoad(): Promise<$Data> {
        return new Promise((resolve, reject) => {
            if (this.isLoaded()) {
                resolve(this.get());
            } else {
                this.load()
                    .then((resp) => {
                        resolve(resp);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }
        })
    }

    public isLoaded(): boolean {
        return this.get() != null;
    }

    public invalidate(): void {
        this.storeCached(null);
    }

}